<div>
  <div class="user-message-chat">
    <!-- Display the message text -->
    <div
      *ngIf="type === 'Text' || type === 'Attachments'"
      class="user-message"
      [ngStyle]="{
        'background-color': configs?.colors?.user_message_background,
        color: configs?.colors?.user_message_text,
        border: '1px solid ' + configs?.colors?.bot_message_border,
        'font-family': configs?.fonts?.default_font,
      }"
    >
      {{ messageText }}
    </div>
    <div
      *ngIf="type === 'Button'"
      class="user-message user-hand"
      [ngStyle]="{
        'background-color': configs?.colors?.user_message_text,
        color: configs?.colors?.user_message_background,
        border: '1px solid ' + configs?.colors?.user_message_background
      }"
    >
      {{ messageText }}
      <svg
        class="hand-icon"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 384 512"
      >
        <path
          [attr.fill]="configs?.colors?.user_message_background"
          d="M135.7 0c23.6 0 43.8 20.7 43.8 44.8v99.9c17-16.3 49.8-18.3 70.9 6.3 22.8-14.3 53-2.1 62.3 16.5C361.9 158.4 384 189.3 384 240c0 2.7-.2 13.3-.2 16 .2 62-31.1 76.9-38.3 123.7C343.7 391.4 333.6 400 321.8 400H150.3l0 0c-18.4 0-35.9-10.6-43.8-28.5C93.4 342.6 57.4 276.1 29.1 264 10.9 256.2 0 242.6 0 224c0-34.2 35.1-57.8 66.9-44.1 8.4 3.6 16.7 8.3 24.9 14.2V44.8c0-23.5 20.5-44.8 43.8-44.8zM136 416h192c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24H136c-13.3 0-24-10.7-24-24v-48c0-13.3 10.7-24 24-24zm168 28c-11 0-20 9-20 20s9 20 20 20 20-9 20-20-9-20-20-20z"
        />
      </svg>
    </div>

    <div *ngIf="files && files.length > 0" class="image-gallery">
      <ng-container *ngFor="let file of files; let i = index">
        <div class="image-item">
          <img
            *ngIf="file.file_display && file.type.startsWith('image/')"
            [src]="file.file_display"
            [alt]="file.name"
            [title]="file.name"
            class="uploaded-image"
          />
          <video
            *ngIf="file.file_display && file.type.startsWith('video/')"
            [src]="file.file_display"
            class="uploaded-image"
            controls
          ></video>
          <p class="file-info">
            #{{ i + 1 }}
            {{
              file.type.startsWith("image/")
                ? "Image"
                : file.type.startsWith("video/")
                ? "Video"
                : "File"
            }}
          </p>
        </div>
      </ng-container>
    </div>
  </div>
  <app-message-timestamp
    *ngIf="input.created_at && input.created_at > 0"
    [createdAt]="input.created_at"
    [textAlign]="'right'"
  >
  </app-message-timestamp>
</div>
